import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../Layout'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useProduct } from '../../Hook/App';
import Spinner from '../../Components/Spinner';
import { fromNow } from '../../Utils';
import { Helmet } from 'react-helmet';

function Index() {
    const { navigate, Share, tooltipe, setTooltipe, user, Loading, show, Showdes, star, addFavorite, item, headerBackground, rels, relsLoad } = useProduct();
    const StarUser = ({ count }) => {
        let STARS = [];
        for (let index = 0; index < count; index++) {
            STARS.push(<i key={index} className="fas fa-star"></i>)

        }
        return STARS
    }

    if (Loading) {
        return (<div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
            <Spinner />
        </div>)
    }


    const LinkFooter = () => {
        if (!user) {
            return (
                <>
                    <Link to={"/Auth"} className="col-4 xborder text-white">
                        <i className="fas fa-phone"></i>
                        <p>تماس</p>
                    </Link>
                    <Link to={"/Auth"} className="col-4 text-white">
                        <i className="fas fa-comment"></i>
                        <p>پیامک</p>
                    </Link>
                </>
            )
        } else {
            return (
                <>
                    <a href={`tel:${item.user && item.user.mobile}`} className="col-4 xborder text-white">
                        <i className="fas fa-phone"></i>
                        <p>تماس</p>
                    </a>
                    <a href={`sms:${item.user && item.user.mobile}`} className="col-4 text-white">
                        <i className="fas fa-comment"></i>
                        <p>پیامک</p>
                    </a>
                </>
            )
        }
    }
console.log(item)
    return (
        <Layout>

            {!item ? <div className='d-flex align-items-center justify-content-center' style={{ height: "100vh" }}><Spinner sm /></div> : (
                <Fragment>
                    <Helmet>
                        <title>بوکان آگهی - {item.name}</title>
                        <meta name="description" content={`${item.category && item.category.title}-${item.name}`} />
                    </Helmet>
                    <div className="product-header">
                        <div className="header col-lg-4" style={{ background: headerBackground }}>
                            <div onClick={() => { navigate(-1) }}><i className="arrow fas fa-arrow-right"></i></div>
                            <div>
                                <i onClick={Share} className="fas fa-share-alt" style={{ marginLeft: '20px' }}></i>
                                <button onClick={addFavorite}><i className={`far fa-star ${star && 'fas fa-star text-warning'}`} ></i></button>
                            </div>
                        </div>
                        {item.images &&
                            <Splide options={{ direction: "rtl", arrows: false }}>
                                {item.images.map((image, i) => {
                                    return (
                                        <SplideSlide onClick={() => navigate('/ShowImages', { state: { images: item.images } })} key={i}>
                                            <img className="item-img" src={image} alt="Image 1" />
                                        </SplideSlide>
                                    )
                                }
                                )}
                            </Splide>
                        }
                    </div>
                    <div className="product-main">
                        {item.type == 'safe' &&
                            <div className="safe-box">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <i className="fas fa-truck mx-2 text-primary"></i>
                                        <small>تحویل فوری / ضمانت بازگشت وجه / خرید امن</small>
                                    </div>
                                    <div className="exclamation" onClick={() => { setTooltipe(true) }}>
                                        <i class="fas fa-exclamation"></i>
                                    </div>
                                </div>
                            </div>
                        }
                        <h5 className="title">{item.name}</h5>
                        <div className="options my-3">
                            <div className="d-flex justify-content-between">
                                <span className="light-text">دسته بندی</span>
                                <span>{item.category && item.category.title}</span>
                            </div>
                            <div className="d-flex justify-content-between mt-2">
                                <span className="light-text">زمان ثبت</span>
                                <span>{fromNow(new Date(item.created_at))}</span>
                            </div>
                        </div>
                        {item.options && item.options.map((option, i) => {
                            return (
                                <div key={i} className="mb-4 d-flex justify-content-between">
                                    <span className="light-text">{option.option.name}</span>
                                    <span>{option.option.type == 'price' ? parseInt(option.value).toLocaleString() + " تومان " : option.value}</span>
                                </div>
                            )
                        })}

                        <div id="des" className={`descriprion ${show && 'all'}`} >{item.meta_data && item.meta_data.description}</div>
                        {
                            item.meta_data && (item.meta_data.description).toString().length > 200 &&
                            <div className="more-btn">
                                <button onClick={Showdes}>
                                    <span className="light-text">{show ? "کمتر" : "بیشتر"}</span>
                                    {show
                                        ?
                                        <i className="light-text fas fa-angle-down"></i>
                                        :
                                        <i className="light-text fas fa-angle-up"></i>}
                                </button>
                            </div>
                        }
                        <p>شماره تماس : {user ? <a href={'tel:' + item.user.mobile}>{item.user.mobile}</a> : <Link to={'/Auth'}>مشاهده</Link>}</p>
                    </div>
                    {user &&
                        item.type == 'safe' &&
                        item.user &&
                        item.shop &&
                        <div className="product-shop">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <div className="img-cont">
                                        <img src={item.shop.logo} alt="" />
                                    </div>

                                    <div className="info">
                                        <span>{item.shop.name}</span>
                                        <div className="d-flex">
                                            <span className="mini-text">{item.user.mobile}</span>
                                        </div>
                                        <span className="mini-text light-text">{fromNow(new Date(item.user.created_at))} عضو شده</span>
                                        <div className="stars">
                                            <div className="d-flex align-items-center">
                                                <StarUser count={item.shop.scores && item.shop.scores.score || 5} />
                                                <span className="mini-text blue">{item.shop.scores_count} نفر</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <a href={'tel:' + item.user.mobile} className="call-btn">
                                    <i className="light-text fas fa-phone"></i>
                                </a>
                            </div>
                        </div>
                    }
                    <div className="product-end">
                        {/* <div className="warninng-box">
                            <div className="d-flex">
                                <div className="col-4 d-flex justify-content-center align-items-center">
                                    <div className="icon">
                                        <div className="d-flex justify-content-center align-items-center">
                                            <i className="fas fa-exclamation"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-8">
                                    <div className="left">
                                        <p>  از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای</p>
                                        <div className="d-flex justify-content-end">
                                            <span>جزییات بیشتر</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div> */}
                        <div className="mb-5 d-flex justify-content-between align-items-center">
                            <span className='light'>شناسه آگهی : {item.id}</span>
                            <Link to="/Report" state={{ id: item.id }} className='badge py-2 bg-danger'>
                                <span className="text-white me-2">گزارش آگهی</span>
                                <i className="fas fa-exclamation text-white"></i>
                            </Link>
                        </div>
                        {relsLoad ?
                            <Spinner />
                            :

                            rels && rels.length ?
                                <>
                                    <p className='light'>آگهی های مشابه</p>
                                    <Splide className='sames mb-0' options={{ pagination: false, perPage: 2, direction: "rtl", arrows: false }}>

                                        {rels.map((rel, i) => {
                                            return (
                                                <SplideSlide key={i}>
                                                    <Link replace to={"/item/" + rel.id} state={{ item: rel }}>
                                                        <div className="same">
                                                            <div className="img">
                                                                <img style={{ objectFit: "cover" }} src={rel.images[0]} alt={rel.name} />
                                                            </div>
                                                            <p>{rel.name}</p>
                                                            <span className='light'>{rel.price == 'توافقی' ? rel.price : parseInt(rel.price).toLocaleString() + " تومان "}</span>
                                                        </div>
                                                    </Link>
                                                </SplideSlide>
                                            )
                                        })
                                        }
                                    </Splide>
                                </>
                                : null
                        }
                    </div>
                    <div className="footer">
                        <div className="main">
                            <div className="row">
                                <Link to={'/Chat?item=' + item.id} className="col-4 text-white">
                                    <i className="fas fa-comments"></i>
                                    <p>چت</p>
                                </Link>
                                <LinkFooter />
                            </div>
                        </div>
                    </div>
                </Fragment>
            )}
            {tooltipe && <ToolTipe hide={() => { setTooltipe(false) }} />}
        </Layout>
    )
}

const ToolTipe = ({ hide }) => {
    return (
        <div className='replay-modal'>
            <div className="replay-main">
                <p>در آگهی‌های "خرید امن"، بوکان آگهی به عنوان معتمد بین خریدار و فروشنده، مبلغ پرداختی شما را تا زمانی که کالا به دستتان برسد نزد خود نگه می‌دارد. همچنین با نظارت بر مراحل ارسال تا تحویل کالا، تضمین کننده صحت معامله شماست.</p>
                <div className="justify-content-end d-flex">
                    <span onClick={hide} className="btn btn-primary" >متوجه شدم</span>
                </div>
            </div>
        </div>
    )
}

export default Index